import axios, { AxiosResponse } from 'axios';
import { AuthResponse, LoginData } from '../interface/login';

const { REACT_APP_API_URL } = process.env;

export const login = async (body: LoginData): Promise<AuthResponse> => {
  try {
    const response: AxiosResponse<AuthResponse> = await axios.post<AuthResponse>(
      `${REACT_APP_API_URL}/auth/login?role[]=admin&role[]=comitato`,
      body,
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Se l'errore è un errore Axios, puoi ottenere il messaggio dalla risposta dell'errore
      if (error.response && error.response.data && error.response.data.message) {
        const errorMessage = error.response.data.message;
        throw new Error(errorMessage);
      } else {
        // Se il messaggio non è disponibile nella risposta, gestisci come errore generico
        throw new Error('Errore nella chiamata API: ' + error.message);
      }
    } else {
      // Altrimenti, è un errore generico
      throw new Error('Errore sconosciuto: ' + error);
    }
  }
};
